export default __webpack_public_path__ + "static/TAOWARARE-849ece1fba794aabdbe3e6c4bc38ffd8.jpg";